// extracted by css-extract-rspack-plugin
export default {"list":"B__0pOCVXyMAOQcJ","conditionText":"O5PKLyneaYxePX9M"};